import styled from "styled-components";
import { HEIGHT_HEADER_GROUP } from "./utils";
//#3d85c6
export const Styles = styled.div`
  &.ignore-sticky-top {
    .reactgrid-content .rg-pane.rg-pane-top {
      top: 0px !important;
    }
  }

  .reactgrid {
    height: auto !important;
  }

  .container-result__total {
    &.hidden {
      display: none;
    }
    z-index: 100;
    position: fixed;
    right: 30px;
    max-width: 100%;
    text-align: center;
    background: #3d85c6;
    color: #fff;
    font-weight: bold;
  }
  .reactgrid-content .rg-pane.rg-pane-top {
    top: ${HEIGHT_HEADER_GROUP}px;
  }
`;

export const TooltipStyles = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 102 !important;
  pointer-events: none;
  transition: transform 0.1s ease-out;
  width: 100%;
  overflow: hidden;

  .tooltip-cell-empty {
    flex-shrink: 0;
  }

  .tooltip-cell {
    flex-shrink: 0;
    position: relative;
    pointer-events: none;

    .tooltip-content {
      position: fixed;
      top: auto;
      bottom: auto;
      left: auto;
      transform: none;
      background: rgba(0, 0, 0, 0.85);
      color: #fff;
      padding: 8px 12px;
      border-radius: 4px;
      font-size: 12px;
      white-space: pre-line;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      z-index: 102 !important;
      min-width: 150px;
      width: 100%;
      max-width: 300px;
      pointer-events: auto;

      &::after {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid rgba(0, 0, 0, 0.85);
      }

      div {
        line-height: 1.5;
      }
    }
  }
`;
export const HeaderCellCustomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .bg-blue {
    background-color: var(--active-color);
  }
  .bg-blue-light {
    background-color: var(--inactive-color);
  }
  .rotate-180 {
    rotate: 180deg;
  }

  .header-filter-icon-custom {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #ffffff;
    height: 25px;
    width: 25px;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    width: 100%;
    gap: 2px;
  }

  &.has-filter {
    .header-text {
      max-width: calc(100% - 24px);
    }
  }

  .header-text {
    text-overflow: ellipsis;
    max-width: 100%;
    flex: 1;
  }

  .required-star {
    color: red;
    margin-left: 2px;
  }

  .header-icon {
    transform: translateY(2px);
  }

  .header-icon.hidden {
    visibility: hidden;
  }

  .header-icon.visible {
    visibility: visible;
  }
`;

export const FilterStyled = styled.div`
  .filter-wrapper {
    padding: 10px;
    border: 1px solid;
    width: 260px;
    max-height: calc(100vh - 260px);
    overflow-y: auto;
    z-index: 101;

    .input-filter {
      height: 36px;
      margin-bottom: 8px;
    }
  }

  .filter-wrapper .ant-form-item {
    margin: 0 0 10px;
  }

  .filter-wrapper .title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .filter-wrapper .title.empty {
    opacity: 0.5;
  }

  /* Sort section */
  .filter-wrapper .sort .ant-radio-group {
    display: flex;
    flex-direction: column;
  }

  /* Filter options */
  .filter-wrapper .filter-options {
    flex-direction: column;
  }

  .filter-wrapper .filter-options.scroll {
    overflow-y: scroll;
  }

  .filter-wrapper .filter-options.scroll::-webkit-scrollbar {
    width: 10px;
  }

  .filter-wrapper .filter-options.scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .filter-wrapper .filter-options.scroll::-webkit-scrollbar-thumb {
    background: #888;
  }

  .filter-wrapper .filter-options.scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .filter-wrapper .filter-options .filter-item {
    width: 228px;

    .ant-checkbox + span {
      transform: translateY(6px);
    }
    .checkbox-label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      max-width: 196px;
    }
  }

  /* HR separator */
  .filter-wrapper hr {
    margin-bottom: 10px;
  }

  /* Action section */
  .filter-wrapper .action {
    display: flex;
    flex-direction: row;
    gap: 5px;
  }

  .filter-wrapper .action p {
    font-size: 14px;
    font-weight: 500;
    text-decoration: underline;
    color: #0989ff;
    cursor: pointer;
  }

  .filter-wrapper .action span {
    color: #0989ff;
  }

  /* Footer section */
  .filter-wrapper .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
    gap: 10px;
  }

  .filter-wrapper .footer .btn {
    width: 120px;
    min-width: fit-content;
  }

  .filter-wrapper .footer .btn-cancel {
    background: #ffffff;
    border: 1px solid #174a83;
    color: #174a83;
  }

  .filter.filter_container {
    position: fixed;
    background: #fff;
    z-index: 101;
  }

  .filter.filter_container.open {
    display: block;
  }

  .filter.filter_container.closed {
    display: none;
  }
`;
